export default __webpack_public_path__ + "static/media/i175vp.c8cba035.webp";